// Hub entry point
import { logger } from '@forest/logger';
import { hasAnalyticsConsent } from '@ophelos/shared/hooks/use-cookie-consent';
import { GlobalErrorBoundary } from '@ophelos/ui/components/global-error-boundary';
import { AuthProvider } from '@ophelos/ui/contexts/workos-auth-context';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { assertSurfaceModeConfig } from './lib/surface-mode';
import './index.css';

assertSurfaceModeConfig();

// Initialize Datadog RUM
if (import.meta.env.VITE_DATADOG_CLIENT_TOKEN) {
  const apiBaseUrl = import.meta.env.VITE_CORE_API_URL;
  const applicationId = import.meta.env.VITE_DATADOG_APPLICATION_ID;
  const clientToken = import.meta.env.VITE_DATADOG_CLIENT_TOKEN;

  if (apiBaseUrl && applicationId && clientToken) {
    logger.init({
      applicationId,
      clientToken,
      service: 'hub',
      env: import.meta.env.MODE,
      version: import.meta.env.VITE_APP_VERSION,
      allowedTracingUrls: [apiBaseUrl],
      // Start from the stored analytics grant; the consent provider flips this
      // live via logger.setTrackingConsent when the banner decision changes.
      trackingConsent: hasAnalyticsConsent(),
    });
  }
}

// biome-ignore lint/style/noNonNullAssertion: root element guaranteed to exist in index.html
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <GlobalErrorBoundary>
      <AuthProvider
        clientId={import.meta.env.VITE_WORKOS_CLIENT_ID || ''}
        redirectUri={import.meta.env.VITE_WORKOS_REDIRECT_URI || ''}
        devMode={import.meta.env.VITE_WORKOS_DEV_MODE === 'true' || import.meta.env.DEV}
        apiHostname={import.meta.env.VITE_WORKOS_API_HOSTNAME}
      >
        <App />
      </AuthProvider>
    </GlobalErrorBoundary>
  </StrictMode>
);
